import { render, staticRenderFns } from "./FaqBox.vue?vue&type=template&id=5246603e&scoped=true&"
import script from "./FaqBox.vue?vue&type=script&lang=js&"
export * from "./FaqBox.vue?vue&type=script&lang=js&"
import style0 from "./FaqBox.vue?vue&type=style&index=0&id=5246603e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5246603e",
  null
  
)

export default component.exports